module.exports = {
  SC001_02_03: "SC001_02_03", // day / week / month
  SC010: "SC010", // impc
  SC011: "SC011", // operator
  SC010_OVERVIEW: "SC010_OVERVIEW", // operator for overview reports with ETOE functionality
  SC011NA: "SC011NA", // operator without arrival
  SC011T: "SC011T", // operator with traffic
  SC011_EDI_EXCHANGE: "SC011_EDI_EXCHANGE", // operator with custom edi exchange filters
  SC011_EDI_EXCHANGE_706: "SC011_EDI_EXCHANGE_706", // operator with custom edi exchange filters for report 706
  SC0011_TRACKED_ITEMS_IN_PREDES_ETOE: "SC0011_TRACKED_ITEMS_IN_PREDES_ETOE", // tracked items in predes
  SC020: "SC020", // airport
  SC021: "SC021", // country
  SC030: "SC030", // mail
  SC060: "SC060", // operator / mailbox
  SC070: "SC070", // transport mode
  SC080: "SC080", // mrd operator / impc
  SC090: "SC090", // carrier
  SC091: "SC091", // handler
  SC001_02_03_mrd: "SC001_02_03_mrd", // mrd pod overview
  SC080_mrdHandlerId: "SC080_mrdHandlerId", // report 402
  SC010_COMPARATIVE: "SC010_COMPARATIVE", // comparative reports
  SC050: "SC050", // operator/user
  SC051: "SC051", // reports
  SC100: "SC100", // item
  SC100_OVERVIEW: "SC100_OVERVIEW", // item criteria for overview reports
};
